<!-- #TODO May want to refactor, but not a high priority -->
@if (selectedUserCount | async; as count) {
  <p class="mat-body" [ngPlural]="count">
    <ng-template ngPluralCase="=1">{{ count }} {{ one }} selected</ng-template>
    <ng-template ngPluralCase="other"
      >{{ count }} {{ plural }} selected
    </ng-template>
  </p>
} @else {
  <p class="mat-body">0 {{ zero }} selected</p>
}
